import request from './request'

/**
 * 获取商品列表
 * @param {string} typeIds - 商品类型ID，多个用逗号分隔，如 '2,3'
 * @param {number} page - 页码，默认为1
 * @param {number} limit - 每页数量，默认为10
 * @returns {Promise} 商品列表数据
 */
export const getProductList = (typeIds = '2,3', page = 1, limit = 10) => {
  return request({
    url: '/api/product/lists',
    method: 'get',
    params: {
      type_ids: typeIds,
      page: page,
      limit: limit
    }
  })
}

/**
 * 获取商品详情
 * @param {string} productId - 商品ID
 * @returns {Promise} 商品详情数据
 */
export const getProductDetail = (productId) => {
  return request({
    url: '/api/product/detail',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品参数
 * @param {string} productId - 商品ID
 * @returns {Promise} 商品参数数据
 */
export const getProductParams = (productId) => {
  return request({
    url: '/api/product/param',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品规格列表
 * @param {string} productId - 商品ID
 * @returns {Promise} 商品规格数据
 */
export const getProductSpecs = (productId) => {
  return request({
    url: '/api/product/specs',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品SKU列表
 * @param {string} productId - 商品ID
 * @returns {Promise} 商品SKU数据
 */
export const getProductSkus = (productId) => {
  return request({
    url: '/api/product/skus',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 根据规格值获取对应SKU
 * @param {string} productId - 商品ID
 * @param {Array} specValueIds - 规格值ID数组
 * @returns {Promise} SKU数据
 */
export const getSkuBySpecs = (productId, specValueIds) => {
  return request({
    url: '/api/product/sku-by-specs',
    method: 'post',
    data: {
      product_id: productId,
      spec_value_ids: specValueIds
    }
  })
}

/**
 * 根据商品ID和规格值获取商品信息（名称、规格、价格、图片）
 * @param {string} productId - 商品ID
 * @param {Array} specValueIds - 规格值ID数组
 * @returns {Promise} 商品信息数据
 */
export const getProductInfoBySpecs = (productId, specValueIds) => {
  return request({
    url: '/api/product/product-info-by-specs',
    method: 'get',
    params: {
      product_id: productId,
      spec_value_ids: specValueIds
    }
  })
}

/**
 * 获取商品定制参数
 * @param {string} productId - 商品ID
 * @returns {Promise} 定制参数列表
 */
export const getProductCustomParams = (productId) => {
  return request({
    url: '/api/product/custom-params',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 提交定制订单
 * @param {Object} data - 定制订单数据
 * @returns {Promise} 提交结果
 */
export const submitCustomOrder = (data) => {
  return request({
    url: '/api/product/submit-custom-order',
    method: 'post',
    data
  })
}



/**
 * 获取商品尺码表格数据
 * @param {string} productId - 商品ID
 * @returns {Promise} 尺码表格数据
 */
export const getProductSizeChart = (productId) => {
  return request({
    url: '/api/product/size-chart',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品尺码参数列表
 * @param {string} productId - 商品ID
 * @returns {Promise} 尺码参数列表
 */
export const getProductSizeParams = (productId) => {
  return request({
    url: '/api/product/size-params',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品尺寸详情表格数据
 * @param {string} productId - 商品ID
 * @returns {Promise} 尺寸详情表格数据
 */
export const getProductSizeDetailChart = (productId) => {
  return request({
    url: '/api/product/size-detail-chart',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品尺寸详情参数列表
 * @param {string} productId - 商品ID
 * @returns {Promise} 尺寸详情参数列表
 */
export const getProductSizeDetailParams = (productId) => {
  return request({
    url: '/api/product/size-detail-params',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品尺寸详情组合列表
 * @param {string} productId - 商品ID
 * @returns {Promise} 尺寸详情组合列表
 */
export const getProductSizeDetailCombinations = (productId) => {
  return request({
    url: '/api/product/size-detail-combinations',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

/**
 * 获取商品尺码组合列表
 * @param {string} productId - 商品ID
 * @returns {Promise} 尺码组合列表
 */
export const getProductSizeCombinations = (productId) => {
  return request({
    url: '/api/product/size-combinations',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}